/** @format */

import axios from "axios";
import swal from "sweetalert";
import {
  DeleteOutlined,
  SaveOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { hisobla } from "./Formula";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Add({ vaqt, date, setDate, havza }) {
  const keyDown = (e) => {
    if (e.key === "Enter") {
      const fields = Array.from(document.querySelectorAll("input")) || [];

      const position = fields.indexOf(e.target);

      fields[position + 1] && fields[position + 1].focus();

      if (position == fields.length - 1) {
        fields[1].focus();
      }
    }
  };

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [ldate, setLdate] = useState(date);
  const [changed, setChanged] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/asosiymanbalar/birkun?date=" +
            date +
            "&vaqt=" +
            vaqt +
            "&havza=" +
            havza,
          header()
        );
        setData(res.data.indData);
        setHasData(res.data.hasData);
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    if (date) {
      fetchData();
    }
  }, [date, vaqt, havza]);

  const setHange = (v, id) => {
    let ind = { ...data };
    if (ind[id]) {
      ind[id].suvi = v;
      if (v !== "") {
        setChanged(true);
      }
      ind = hisobla(ind);
    }
    setData(ind);
  };

  const doIt = async (action) => {
    try {
      const res = await axios.post(
        getEnv('REACT_APP_BASE_URL') + "/v1/region/asosiymanbalar/" + action,
        { date, data, vaqt },
        header()
      );

      if (res.data.status === 200) {
        swal("Muvaffaqiyatli", res.data.message, "success");
        setDate("");
        navigate("/asosiymanbalar");
      } else {
        swal("Xato", res.data.message, "error");
      }
    } catch (e) {
      console.log("Xato", e);
      swal("Xato", "Server bilan aloqa yo'q", "error");
    }
  };

  const deleteHandler = () => {
    let prompt = window.confirm(
      "Siz rostdan ham " +
        date +
        " dagi" +
        (vaqt == "ortacha" ? " kunlik o'rtacha " : " ertalabki ") +
        "ma'lumotlarni o'chirib yuborishni hohlaysimi"
    );
    if (prompt) {
      doIt("delete");
    }
  };

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            <div className='d-flex'>
              <NavLink
                to='/asosiymanbalar'
                className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                <ArrowLeftOutlined />
                &nbsp;&nbsp;&nbsp;Bekor qilish
              </NavLink>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {hasData ? (
                <button
                  className='btn btn-sm btn-outline-danger d-flex align-items-center'
                  onClick={() => deleteHandler()}>
                  O'chirish &nbsp;&nbsp;&nbsp;
                  <DeleteOutlined />
                </button>
              ) : null}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {changed ? (
                <button
                  className='btn btn-sm btn-outline-primary d-flex align-items-center'
                  onClick={() => doIt("save")}>
                  Saqlash &nbsp;&nbsp;&nbsp;
                  <SaveOutlined />
                </button>
              ) : null}
            </div>
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='date'
                  className='form-control form-control-sm'
                  value={ldate}
                  onChange={(e) => setLdate(e.target.value)}
                />
              </div>
            </li>
          </ul>
        </div>

        <div id='content'>
          <div id='tableFlexible' style={{ height: "80vh" }}>
            {loading ? (
              <LoadingCard loading={loading} heightSize='80vh' />
            ) : (
              <table
                id='tblData'
                className='table table-bordered table-style fixedHeader'
                style={{ width: "unset" }}>
                <thead className=''>
                  <tr>
                    <th colSpan={4}>
                      {hasData ? (
                        <span>
                          {date} dagi "
                          <u>
                            {vaqt == "ortacha"
                              ? " kunlik o'rtacha "
                              : " ertalabki "}
                          </u>
                          " ma'lumotlarni o'zgartirish
                        </span>
                      ) : (
                        <span>
                          {date} ga "
                          <u>
                            {vaqt == "ortacha"
                              ? " kunlik o'rtacha "
                              : " ertalabki "}
                          </u>
                          " ma'lumotlarni kiritish
                        </span>
                      )}
                    </th>
                  </tr>

                  <tr>
                    <th>T/R</th>

                    <th>
                      Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                    </th>

                    <th>O’lchov birligi</th>
                    <th style={{ width: "110px" }}>Suvi</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.keys(data).length > 0 ? (
                    Object.keys(data).map((d, i) => {
                      return (
                        <tr key={i}>
                          <th>{i + 1}</th>

                          <th>{data[d].manba_nomi}</th>

                          <th>{data[d].birligi}</th>

                          <td className='inserttr'>
                            <input
                              type='number'
                              className={
                                data[d].ro == "1"
                                  ? "insertable ro"
                                  : "insertable"
                              }
                              value={data[d].suvi}
                              onChange={(e) => setHange(e.target.value, d)}
                              readOnly={data[d].ro == 1 ? true : false}
                              onKeyDown={keyDown}
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <h1>Avval sanani tanlang</h1>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
